import setupRoutes from './router'
import '_/styles/index.less'

/**
 * After content loaded, set up routing and initialize react components
 */
global.document.addEventListener('DOMContentLoaded', setupRoutes)



// WEBPACK FOOTER //
// ./modules/client/index.js